export { default } from './ColumnsContent';



// WEBPACK FOOTER //
// ./src/components/Hocs/ColumnsContent/index.js